import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { focusContainer } from '../../utils/focusContainer.js';
import '../../utils/opacityDisabled.js';
import { scaleSmallIcon } from '../Badge/styles.js';

const StyledFilterBadge = styled.label(({ theme: { olist: { components: { badge }, }, }, selected, disabled, }) => css `
    height: 24px;

    padding-inline: ${badge['padding-inline']};

    position: relative;

    font-size: ${badge['font-size']};
    line-height: ${badge['line-height']};
    font-weight: ${badge['font-weight']};

    display: flex;
    align-items: center;

    background-color: ${badge.filter.background};
    border: 1px solid ${badge.filter['border-color']};

    border-radius: ${badge.radius.pill};

    cursor: pointer;

    ${selected
    ? css `
          background-color: ${badge.filter.selected.background};
          color: ${badge.filter.selected.color};

          svg {
            ${scaleSmallIcon()};
          }

          ${!disabled &&
        css `
            &:hover {
              background-color: ${badge.filter.selected.hover.background};
            }

            &:active {
              color: ${badge.filter.selected.active.color};
            }
          `}
        `
    : css `
          &:hover {
            background-color: ${badge.filter.hover.background};
          }

          &:active {
            background-color: ${badge.filter.active.background};
          }
        `}

    ${focusContainer({ within: true }) ``}

    ${disabled &&
    css `
      &,
      input {
        opacity: ${badge.filter.disabled.opacity};
      }
    `}

    > button {
      all: unset;
      display: flex;
      align-items: center;
      ${scaleSmallIcon(true)};
    }

    > input {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      margin: 0;
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
    }

    ${margins}
  `);

export { StyledFilterBadge };
